@if (onDisabled() && useAlert()) {
  <app-custom-sonner-toaster-uif
    (click)="clicked.emit()"
    [type]="type()"
    [title]="messageTitle()"
    [description]="description()"
  />
}
@if (blocKInput()) {
  <fieldset
    [class.opacity-50]="onDisabled()"
    [class.pointer-events-none]="onDisabled()"
    [disabled]="onDisabled()"
    class="transition-opacity"
  >
    <ng-container [ngTemplateOutlet]="pageContent"></ng-container>
  </fieldset>
} @else {
  <ng-container [ngTemplateOutlet]="pageContent"></ng-container>
}

<ng-template #pageContent>
  <ng-content></ng-content>
</ng-template>
